import { FiChevronRight } from "react-icons/fi";
import { Link } from "react-router-dom";

export const QuickAction = ({ to, icon, title, subtitle }) => (
  <Link
    to={to}
    className='flex items-center gap-3 px-2 py-2.5 rounded-md hover:bg-gray-50'
  >
    <span className='w-9 h-9 rounded-md bg-everglade-50 text-everglade-700 flex items-center justify-center shrink-0'>
      {icon}
    </span>
    <span className='flex-1 min-w-0'>
      <span className='block text-sm font-medium text-gray-800'>{title}</span>
      <span className='block text-xs text-gray-500 truncate'>{subtitle}</span>
    </span>
    <FiChevronRight size={16} className='text-gray-300 shrink-0' />
  </Link>
)